import React, { Component } from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import { propTypes } from 'util/types';
import { FormattedMessage } from '../../util/reactIntl';
import css from './CompanyListingCard.css';
import { ensureListing } from 'util/data';
import { NamedLink, ResponsiveImage } from 'components/index';
import StarRatings from 'react-star-ratings';
import { lazyLoadWithDimensions } from 'util/contextHelpers';
import { createSlug } from 'util/urlHelpers';


class ListingImage extends Component {
    render() {
        return <ResponsiveImage {...this.props} />;
    }
}

const LazyImage = lazyLoadWithDimensions(ListingImage, { loadAfterInitialRendering: 3000 });

function NextArrow(props) {
    const { style, onClick } = props;
    return (
        <img
            src={'/static/images/searchPage/company_Arrow.png'}
            className={css.ArrowRight}
            style={{ ...style, display: 'block', zIndex: '2' }}
            onClick={onClick}
            alt="NextArrow"
        />
    );
}

function PrevArrow(props) {
    const { style, onClick } = props;
    return (
        <img
            src={'/static/images/searchPage/company_Arrow.png'}
            className={css.ArrowLeft}
            style={{ ...style, display: 'block', zIndex: '2' }}
            onClick={onClick}
            alt="PrevArrow"
        />
    );
}
const sliderSettings = {
    appendDots: dots => (
        <div
            style={{
                backgroundColor: "transparent",
                borderRadius: "10px",
                padding: "10px"
            }}
        >
            <ul style={{ margin: "0px" }}> {dots} </ul>
        </div>
    ),
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    swipe: false,
    dots: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
        {
            breakpoint: 550,
            settings: {
                slidesToScroll: 1,
                swipe: true,
                arrows: false,
                dots: true,
            },
        },
    ],
};

export const CompanyListingCard = ({ listing, setActiveListing, reviews, authorNumberOfListings }) => {
    const currentListing = ensureListing(listing);
    const id = currentListing.id.uuid;
    const noPros = authorNumberOfListings && authorNumberOfListings.pro ? authorNumberOfListings.pro : 0;
    const noRentals = authorNumberOfListings && authorNumberOfListings.rental ? authorNumberOfListings.rental : 0;
    const noClasses = authorNumberOfListings && authorNumberOfListings.classes ? authorNumberOfListings.classes : 0;
    const { title, description, publicData } = currentListing.attributes;
    const slug = createSlug(title);
    const companyImages = currentListing.images
    const currentAddress = publicData.location.address || "";

    const rating = publicData.rating && !isNaN(publicData.rating) ? publicData.rating : 0;
    const reviewcount = publicData.total_reviewers || 0;

    return (<NamedLink name="ListingPage" params={{ id, slug }} className={css.companyLink}>
        <div className={css.companyMain}
            onMouseEnter={setActiveListing && (() => setActiveListing(currentListing.id))}
            onMouseLeave={setActiveListing && (() => setActiveListing(null))}
        >
            <div className={css.companyCard}>
                <div className={css.card}>
                    <div className={css.companyCardWrapper}>
                        <div className={css.sliderWrapper}>
                            <Slider {...sliderSettings}
                                className={css.slider}>
                                {companyImages.map((image) => (
                                    <div key={image.id.uuid} className={css.cardImage}>
                                        <LazyImage
                                            alt={listing.attributes.title}
                                            className={css.popularImage}
                                            image={image}
                                            variants={['scaled-small', 'square-small2x']}
                                        />
                                    </div>
                                ))
                                }
                            </Slider>
                        </div>
                        <div className={css.cardInfoWrapper}>
                            <div className={css.mobileStarWrapper}>
                                <span className={css.rating}>
                                    <StarRatings
                                        rating={rating}
                                        starRatedColor="#00bfe6"
                                        numberOfStars={5}
                                        starDimension="17px"
                                        starSpacing="1px"
                                    />
                                </span>
                                <span className={css.reviewCount}>
                                    <FormattedMessage id="CompanyListingCard.reviewCount" values={{ count: reviewcount }} />
                                </span>
                            </div>
                            <span className={css.companyName}>{title}</span>
                            <div className={css.address}>
                                <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.5931 8.64795C7.9612 8.64795 8.32104 8.53879 8.62711 8.33429C8.93317 8.12978 9.17172 7.8391 9.31259 7.49902C9.45346 7.15894 9.49032 6.78472 9.4185 6.42369C9.34669 6.06266 9.16943 5.73103 8.90914 5.47074C8.64885 5.21045 8.31723 5.03319 7.95619 4.96138C7.59516 4.88957 7.22095 4.92642 6.88086 5.06729C6.54078 5.20816 6.2501 5.44671 6.0456 5.75278C5.84109 6.05884 5.73193 6.41868 5.73193 6.78678C5.73193 7.2804 5.92802 7.75379 6.27706 8.10283C6.62609 8.45186 7.09949 8.64795 7.5931 8.64795ZM6.93239 15.0783C7.0189 15.1655 7.12182 15.2347 7.23522 15.282C7.34862 15.3292 7.47025 15.3535 7.5931 15.3535C7.71595 15.3535 7.83758 15.3292 7.95098 15.282C8.06438 15.2347 8.1673 15.1655 8.25381 15.0783L12.0599 11.2629C12.9439 10.3793 13.546 9.25347 13.7901 8.02768C14.0342 6.80189 13.9092 5.53125 13.4311 4.37647C12.9529 3.2217 12.1431 2.23466 11.1039 1.54021C10.0647 0.845764 8.84295 0.475098 7.5931 0.475098C6.34325 0.475098 5.12147 0.845764 4.0823 1.54021C3.04313 2.23466 2.23325 3.2217 1.75511 4.37647C1.27696 5.53125 1.15202 6.80189 1.3961 8.02768C1.64017 9.25347 2.24229 10.3793 3.1263 11.2629L6.93239 15.0783ZM3.15422 6.35872C3.2178 5.69523 3.42876 5.05431 3.77168 4.48277C4.11461 3.91122 4.58085 3.42348 5.13636 3.05515C5.86613 2.57599 6.72009 2.32069 7.5931 2.32069C8.46611 2.32069 9.32007 2.57599 10.0498 3.05515C10.6016 3.42222 11.0652 3.907 11.4073 4.47464C11.7494 5.04228 11.9614 5.67867 12.0281 6.33804C12.0949 6.99742 12.0147 7.66338 11.7933 8.28805C11.5719 8.91272 11.2148 9.48057 10.7478 9.95076L7.5931 13.1054L4.43842 9.95076C3.97083 9.48513 3.61293 8.9211 3.39078 8.29973C3.16863 7.67835 3.08781 7.01526 3.15422 6.35872ZM14.1072 17.2093H1.07902C0.832214 17.2093 0.595517 17.3074 0.420999 17.4819C0.246481 17.6564 0.148438 17.8931 0.148438 18.1399C0.148438 18.3867 0.246481 18.6234 0.420999 18.7979C0.595517 18.9724 0.832214 19.0705 1.07902 19.0705H14.1072C14.354 19.0705 14.5907 18.9724 14.7652 18.7979C14.9397 18.6234 15.0378 18.3867 15.0378 18.1399C15.0378 17.8931 14.9397 17.6564 14.7652 17.4819C14.5907 17.3074 14.354 17.2093 14.1072 17.2093Z" fill="#10D6EB" />
                                </svg>
                                <span>{currentAddress}</span></div>
                            <span className={css.companyInfo}>{description}</span>
                            <div className={css.listingTypeWrapper} >
                                <span className={css.listingTypeCount}>{`${noClasses} Class Types`}</span>
                                <span className={css.listingTypeCount}>{`${noPros} Pro’s`} </span>
                                <span className={css.listingTypeCount}>{`${noRentals} Rental Spaces`}</span>
                            </div>
                            <div className={css.starWrapper}>
                                <span className={css.rating}>
                                    <StarRatings
                                        rating={rating}
                                        starRatedColor="#00bfe6"
                                        numberOfStars={5}
                                        starDimension="20px"
                                        starSpacing="1px"
                                    />
                                </span>
                                <span className={css.reviewCount}>
                                    <FormattedMessage id="CompanyListingCard.reviewCount" values={{ count: reviewcount }} />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </NamedLink >);
}

CompanyListingCard.propTypes = {
    listing: propTypes.listing,
    setActiveListing: PropTypes.func,
};

export default CompanyListingCard;